__webpack_require__.p = "/gel-calculator/";